// ** Initial State
const initialState = {
  allData: [],
  data: null,
  trashDataWithPagintion: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true
}

const trash = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }

    case 'GET_USER_DATA':
        return { ...state, data: action.data }
    case 'TRUNCATE_USER_DATA':
          return { ...state, data: null }
    case 'GET_ALL_TRASH_WITH_PAGINATION':
          return { ...state, trashDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
          return { ...state, pageLoader: action.data }
    default:
      return { ...state }
  }
}
export default trash
